/**
 * Localized display name for a city row, mirroring the derivation ExplorePage
 * feeds into `buildCategorySeo` (name.<lang> → name.en → titleised slug).
 *
 * Route loaders use this to prefetch `cityArticlesQueryOptions` under the
 * exact key the `useCityArticles` hook will read — the key includes the
 * display name, so a mismatch here would mean prefetching a query nobody
 * consumes and SSR-ing an empty articles section.
 */
export function cityDisplayName(
  cityRow: { name?: unknown } | null | undefined,
  lang: string,
  citySlug: string,
): string {
  const name = cityRow?.name as Record<string, string | undefined> | undefined;
  const fromDb = (name?.[lang] || name?.en)?.trim();
  if (fromDb) return fromDb;
  return citySlug
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
